import { render, staticRenderFns } from "./SorteoFreidoraFinPromocion.vue?vue&type=template&id=29928f51&scoped=true&"
import script from "./SorteoFreidoraFinPromocion.vue?vue&type=script&lang=js&"
export * from "./SorteoFreidoraFinPromocion.vue?vue&type=script&lang=js&"
import style0 from "./SorteoFreidoraFinPromocion.vue?vue&type=style&index=0&id=29928f51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29928f51",
  null
  
)

export default component.exports